<template>
  <div>
    <transition name="fade">
      <v-overlay :z-index="201" v-if="showJumpToPickNr"></v-overlay>
    </transition>
    <v-dialog persistent autofocus :value="showJumpToPickNr" hide-overlay>
      <v-card class="unmarkable">
        <v-card-title>
          <v-icon>
            $vuetify.icons.jumpToPick
          </v-icon>
          &nbsp; Jump to pick
        </v-card-title>
        <v-divider />
        <v-card flat>
          <v-card-text>
            <NumberInput
              :value="pickNrItem.value"
              @valueChange="newValue => (pickNrItem.value = Number(newValue))"
              @valueInput="newValue => (pickNrItem.current = newValue)"
              @valid="isValid => (pickNrItem.valid = isValid)"
              label="Pick Nr"
              :min="1"
              :max="maxValue"
              :enforceMinMax="true"
              ref="numberInput"
            ></NumberInput>
          </v-card-text>
        </v-card>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="error" text @click="cancel">Cancel</v-btn>
          <v-btn
            color="secondary darken-1"
            text
            @click="jumpToPick"
            :disabled="!valid"
            >Jump to pick</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { TOGGLE_SHOW_JUMP_TO_PICK_NR } from "../../store/modules/showComponents/constants";
import NumberInput from "./helpers/NumberInput";
import uptFile from "../utils/nonReactiveState/uptFile";

export default {
  name: "JumpToPickNr",

  data: function() {
    return {
      pickNrItem: { value: 1, current: 1, valid: true }
    };
  },

  components: { NumberInput },

  computed: {
    valid() {
      return this.pickNrItem.valid;
    },
    showJumpToPickNr() {
      return this.$store.state.showComponents.showJumpToPickNr;
    },
    maxValue() {
      return uptFile.pickData.driveData.data.length;
    }
  },

  watch: {
    showJumpToPickNr(newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        this.pickNrItem = { value: 1, current: 1, valid: true };
        this.$nextTick(() => this.$refs.numberInput.focus());
      }
    }
  },

  methods: {
    jumpToPick() {
      this.$store.dispatch(TOGGLE_SHOW_JUMP_TO_PICK_NR);
      document
        .getElementById("tableEditor")
        .getElementsByClassName("v-data-table__wrapper")[0].scrollTop =
        (this.pickNrItem.value - 1) * this.$store.state.tableView.zoom;
    },
    cancel() {
      this.$store.dispatch(TOGGLE_SHOW_JUMP_TO_PICK_NR);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>
